// @module Eureka.MaxaPunchout.MaxaPunchout
define('Eureka.MaxaPunchout.MaxaPunchout.View'
	,	[
		'eureka_maxapunchout_maxapunchout.tpl'

		,	'Eureka.MaxaPunchout.MaxaPunchout.SS2Model'

		,	'Backbone'
	]
	, function (
		eureka_maxapunchout_maxapunchout_tpl

		,	WizardModule
		,	Backbone
		, 	ProfileModel
		,	CheckoutModel
	)
	{
		'use strict';

		// @class EurekaSolutions.JacuzziCheckout.JacuzziCheckout.View @extends Backbone.View
		return WizardModule.extend({

			template: eureka_maxapunchout_maxapunchout_tpl

			,	initialize: function (options) {

			}


			//@method getContext @return EurekaSolutions.JacuzziCheckout.JacuzziCheckout.View.Context
			,	getContext: function getContext()
			{
				console.log("In the Punchout");
				return {
					message: "In Here"
				};
			}
		});
	});
